<div class="container-fluid">
<div
  *ngIf="
    showApprovalPenaltyData &&
    showSubmissionPenaltyData &&
    showLateLeaveApplicationPenaltyData &&
    showLateLeaveApprovalPenaltyData
  "
>
<div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;" *ngIf="!isMyReport">
        <h5><i class="fa fa-circle" style="color:#800000;"></i> &nbsp;
          Penalty Summary</h5>
      </div>
  <div id="mainContent" class="container">
    <div class="modal-body" *ngIf="!isMyReport">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Financial Year<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedFinancialYear"
                (change)="onFinancialYearSlected()"
              >
                <option value="">Select Year</option>
                <option
                  *ngFor="let finance of financialList"
                  [ngValue]="finance"
                >
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Roles<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select
                  multiple
                  [(ngModel)]="selectedRole"
                  #designateRole="ngModel"
                >
                  <mat-option
                    (click)="selectAllRole(designateRole, roleList)"
                    [value]="0"
                    >Select All
                  </mat-option>
                  <mat-option
                    #item
                    *ngFor="let role of roleList"
                    [value]="role"
                  >
                    {{ role.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Branch<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select
                  multiple
                  [(ngModel)]="selectedBranch"
                  #designateBranch="ngModel"
                >
                  <mat-option
                    (click)="selectAllBranch(designateBranch, branchList)"
                    [value]="0"
                    >Select All
                  </mat-option>
                  <mat-option
                    #item
                    *ngFor="let branch of branchList"
                    [value]="branch"
                  >
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Closing Date<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedClosing"
              >
                <option value="">Select Date</option>
                <option
                  *ngFor="let closing of closingDateList"
                  [value]="closing.id"
                >
                  {{ closing.closingDate }}
                </option>
              </select>
            </div>
          </div>
        </div> -->
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Closing Date<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select
                  multiple
                  [(ngModel)]="selectedClosing"
                  #designateClosingDate="ngModel"
                >
                  <mat-option
                    (click)="selectAllClosingDate(designateClosingDate, closingDateList)"
                    [value]=""
                    >Select All
                  </mat-option>
                  <mat-option
                    #item
                    *ngFor="let closing of closingDateList"
                    [value]="closing.id"
                  >
                    {{ closing.closingDate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          <button
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onViewReport()"
          >
            View Report
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button
            (click)="exportToExcelClick()"
            class="btn btn-sm btn-block btn-outline-theme"
          >
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button
            (click)="exportToPDFClick()"
            class="btn btn-sm btn-block btn-outline-theme"
          >
            <i class="fa fa-file-pdf-o mr-2"></i>Export As PDF
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="container" id="mainContent" *ngIf="reportList.length>0">
    <div class="row pt-2 justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>

  <div class="container" *ngFor="let penalty of reportList">
    <div class="row ">
      <div class="col-sm-6">
        <label class="col-form-label"><b>Closing date: </b>{{ penalty.closingDate ? (penalty.closingDate | date:'dd-MM-yyyy') : 'Not Closed' }}</label>
      </div>
    </div>
    <div class="row ">
      <div class="col-sm-6">
        <label class="col-form-label"><b>Role: </b>{{ penalty.role }}</label>
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label"
          ><b>Branch: </b>{{ penalty.branch }}</label
        >
      </div>
    </div>

    <div class="pb-2">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th>Employee Name</th>
          <th>Approval Penalty</th>
          <th>Submission Penalty</th>
          <th>Late Leave Application Penalty</th>
          <th>Late Leave Approval Penalty</th>
          <th>Total Penalty</th>
        </tr>
        <tbody *ngFor="let penaltyDetail of penalty.penaltyDetails">
          <tr>
            <td>
              {{ penaltyDetail.firstName }}
              {{
                penaltyDetail.middleName != "null"
                  ? penaltyDetail.middleName
                  : ""
              }}
              {{ penaltyDetail.lastName }}
            </td>
            <td
              *ngIf="penaltyDetail.lateApproval != 0; else other_content1"
              (click)="getApprovalPenaltyDetails(penaltyDetail.usersId,penalty.closingDate)"
            >
              <a style="cursor: pointer; color: #800000;text-decoration: underline;">{{
                penaltyDetail.lateApproval
              }}</a>
            </td>
            <ng-template #other_content1>
              <td>{{ penaltyDetail.lateApproval }}</td>
            </ng-template>
            <td
              *ngIf="penaltyDetail.lateSubmission != 0; else other_content2"
              (click)="getSubmissionPenaltyDetails(penaltyDetail.usersId,penalty.closingDate)"
            >
              <a style="cursor: pointer; color: #800000;text-decoration: underline;">{{
                penaltyDetail.lateSubmission
              }}</a>
            </td>
            <ng-template #other_content2>
              <td>{{ penaltyDetail.lateSubmission }}</td>
            </ng-template>
            <td
              *ngIf="penaltyDetail.lateLeaveApply != 0; else other_content3"
              (click)="
                getLateLeaveApplicationPenaltyDetails(penaltyDetail.usersId,penalty.closingDate)
              "
            >
              <a style="cursor: pointer; color: #800000;text-decoration: underline;">{{
                penaltyDetail.lateLeaveApply
              }}</a>
            </td>
            <ng-template #other_content3>
              <td>{{ penaltyDetail.lateLeaveApply }}</td>
            </ng-template>
            <td
              *ngIf="penaltyDetail.lateLeaveApproval != 0; else other_content4"
              (click)="
                getLateLeaveApprovalPenaltyDetails(penaltyDetail.usersId,penalty.closingDate)
              "
            >
              <a style="cursor: pointer; color: #800000;text-decoration: underline;">{{
                penaltyDetail.lateLeaveApproval
              }}</a>
            </td>
            <ng-template #other_content4>
              <td>{{ penaltyDetail.lateLeaveApproval }}</td>
            </ng-template>
            <td>{{ getPenaltyTotal(penaltyDetail) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td>{{ getApprovalTotal(penalty.penaltyDetails) }}</td>
            <td>{{ getLateSubmissionTotal(penalty.penaltyDetails) }}</td>
            <td>{{ getLateLeaveTotal(penalty.penaltyDetails) }}</td>
            <td>{{ getLeaveApprovalTotal(penalty.penaltyDetails) }}</td>
            <td>{{ getPenaltiesTotal(penalty.penaltyDetails) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
</div>

<div class="pt-3">
<div class="container pt-3 pb-2" id="mainContent" *ngIf="!showApprovalPenaltyData">
  <div class="row justify-content-center text-center pt-2">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>

  <div class="row mt-4">
    <div class="col-md-4" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-4">
      <span class="bg-theme-title">Approval Penalty Details</span>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToExcelDiaryApprovalPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToPDFDiaryApprovalPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-4"></div>
    <div class="col-md-6" >
      <span class="bg-theme-title"
        >Closing Date :
        {{
          approvalPenaltyDetailsList.closingDate === null
            ? "Not Closed"
            : (approvalPenaltyDetailsList.closingDate | date: "dd-MMM-yyyy")
        }}</span
      >
    </div>
  </div>
  <div class="pt-4">
    <div class="row col-md-12">
      <div>
        <span style="font-size: 14px; font-weight: bold;">Approver Name : </span
        >{{ approvalPenaltyDetailsList.firstName }}
        {{ approvalPenaltyDetailsList.lastName }}
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Penalty Date</th>
            <th>EmployeeName</th>
            <th>Week StartDate</th>
            <th>Week EndDate</th>
            <th>Week Status</th>
            <th>Submitted Date</th>
            <th>Penalty Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let penaltyDetail of approvalPenaltyDetailsList.penaltyDetails;
              let penaltyDetailIndex = index;
              let penaltyCount = count
            "
          >
            <ng-container
              *ngFor="
                let detail of penaltyDetail.details;
                let detailIndex = index;
                let detailCount = count
              "
            >
              <ng-container
                *ngFor="
                  let weekDetail of detail.weekDetails;
                  let weekDetailIndex = index;
                  let weekDetailCount = count
                "
              >
                <tr *ngIf="detailIndex == 0 && weekDetailIndex == 0">
                  <td
                    [attr.rowspan]="getRowSpanForPenalty(penaltyDetail.details)"
                  >
                    {{ penaltyDetail.penaltyDate | date: "dd-MMM-yyyy" }}
                  </td>
                  <td [attr.rowspan]="weekDetailCount">
                    {{ detail.approveeFName }} {{ detail.approveeLName }}
                  </td>
                  <td>{{ weekDetail.weekStartDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.weekEndDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>{{ weekDetail.submittedDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr *ngIf="detailIndex != 0 && weekDetailIndex == 0">
                  <td [attr.rowspan]="weekDetailCount">
                    {{ detail.approveeFName }} {{ detail.approveeLName }}
                  </td>
                  <td>{{ weekDetail.weekStartDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.weekEndDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>{{ weekDetail.submittedDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr *ngIf="weekDetailIndex != 0">
                  <td>{{ weekDetail.weekStartDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.weekEndDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>{{ weekDetail.submittedDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr
                  *ngIf="
                    detailCount == detailIndex + 1 &&
                    weekDetailCount == weekDetailIndex + 1
                  "
                  style="background-color: #e1f4f7"
                >
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ calculateApprovalTotal(penaltyDetail.details) }}</td>
                </tr>
                <tr
                  *ngIf="
                    penaltyCount == penaltyDetailIndex + 1 &&
                    detailCount == detailIndex + 1 &&
                    weekDetailCount == weekDetailIndex + 1
                  "
                  style="background-color: #e1f4f7"
                >
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ approvalPenaltyTotal }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

<div class="pt-1">
<div class="container pt-3 pb-2" id="mainContent" *ngIf="!showSubmissionPenaltyData">
  <div class="row justify-content-center text-center pt-2">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row mt-4">
    <div class="col-md-4" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-4">
      <span class="bg-theme-title">Submission Penalty Details</span>
    </div>
    <div class="col-md-2">
      <button
        (click)="exportToExcelDiarySubmissionPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>

    <div class="col-md-2">
      <button
        (click)="exportToPDFSubmissionPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-6">
      <span class="bg-theme-title"
        >Closing Date :
        {{
          submissionPenaltyDetailsList.closingDate === null
            ? "Not Closed"
            : (submissionPenaltyDetailsList.closingDate | date: "dd-MMM-yyyy")
        }}</span
      >
    </div>
  </div>
  <div class="pt-4">
    <div class="row col-md-12">
      <div>
        <span style="font-size: 14px;font-weight: bold;">Employee Name :</span
        >{{ submissionPenaltyDetailsList.firstName }}
        {{ submissionPenaltyDetailsList.lastName }}
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Penalty Date</th>
            <th>Week StartDate</th>
            <th>Week EndDate</th>
            <th>Week Status</th>
            <th>Penalty Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let penaltyDetail of submissionPenaltyDetailsList.penaltyDetails;
              let penaltyDetailIndex = index;
              let penaltyCount = count
            "
          >
            <ng-container
              *ngFor="
                let weekDetail of penaltyDetail.weekDetails;
                let weekDetailIndex = index;
                let weekDetailCount = count
              "
            >
              <tr *ngIf="weekDetailIndex == 0">
                <td [attr.rowspan]="getRowSpanSubmissionPenalty(penaltyDetail)">
                  {{ penaltyDetail.penaltyDate | date: "dd-MMM-yyyy" }}
                </td>
                <td>{{ weekDetail.weekStartDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.weekEndDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.status }}</td>
                <td>{{ weekDetail.penaltyAmount }}</td>
              </tr>
              <tr *ngIf="weekDetailIndex != 0">
                <td>{{ weekDetail.weekStartDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.weekEndDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.status }}</td>
                <td>{{ weekDetail.penaltyAmount }}</td>
              </tr>
              <tr
                *ngIf="weekDetailCount == weekDetailIndex + 1"
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td>{{ calculateSubmissionTotal(penaltyDetail) }}</td>
              </tr>

              <tr
                *ngIf="
                  penaltyCount == penaltyDetailIndex + 1 &&
                  weekDetailCount == weekDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ submissionPenaltyTotal }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

<div class="pt-1">
<div class="container pt-3 pb-2" id="mainContent" *ngIf="!showLateLeaveApplicationPenaltyData">
  <div class="row justify-content-center text-center pt-2">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row mt-4">
    <div class="col-md-4" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-4">
      <span class="bg-theme-title">Late Leave Application Penalty Details</span>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToExcelLateLeaveApplicationPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToPDFLateLeaveApplPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
      </button>
    </div>

  </div>
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-6">
      <span class="bg-theme-title"
        >Closing Date :
        {{
          lateLeaveApplicationPenaltyDetailsList.closingDate === null
            ? "Not Closed"
            : (lateLeaveApplicationPenaltyDetailsList.closingDate
              | date: "dd-MMM-yyyy")
        }}</span
      >
    </div>
  </div>
  <div class="pt-4">
    <div class="row col-md-12">
      <div>
        <span style="font-size: 14px;font-weight: bold;">Employee Name :</span
        >{{ lateLeaveApplicationPenaltyDetailsList.firstName }}
        {{ lateLeaveApplicationPenaltyDetailsList.lastName }}
      </div>
    </div>

    <div class="row">
      <table class="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>Penalty Date</th>
            <th>Leave Request Date</th>
            <th>Leave From Date</th>
            <th>Leave To Date</th>
            <th>Late Days</th>
            <th>Penalty Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let penaltyDetail of lateLeaveApplicationPenaltyDetailsList.penaltyDetails;
              let penaltyDetailIndex = index;
              let penaltyCount = count
            "
          >
            <ng-container
              *ngFor="
                let weekDetail of penaltyDetail.weekDetails;
                let weekDetailIndex = index;
                let weekDetailCount = count
              "
            >
              <tr *ngIf="weekDetailIndex == 0">
                <td
                  [attr.rowspan]="getRowSpanLateLeaveApplPenalty(penaltyDetail)"
                >
                  {{ penaltyDetail.penaltyDate | date: "dd-MMM-yyyy" }}
                </td>
                <td>{{ weekDetail.leaveRequestDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.leaveFromDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.leaveToDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.lateDays }}</td>
                <td>{{ weekDetail.penaltyAmount }}</td>
              </tr>
              <tr *ngIf="weekDetailIndex != 0">
                <td>{{ weekDetail.leaveRequestDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.leaveFromDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.leaveToDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ weekDetail.lateDays }}</td>
                <td>{{ weekDetail.penaltyAmount }}</td>
              </tr>
              <tr
                *ngIf="weekDetailCount == weekDetailIndex + 1"
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td>{{ calculateLateDaysTotal(penaltyDetail) }}</td>
                <td>{{ calculateLateLeaveApplTotal(penaltyDetail) }}</td>
              </tr>

              <tr
                *ngIf="
                  penaltyCount == penaltyDetailIndex + 1 &&
                  weekDetailCount == weekDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ allLastDaysTotal }}</td>
                <td>{{ lateLeaveApplPenaltyTotal }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

<div class="pt-1">
<div class="container pt-3 pb-2" id="mainContent" *ngIf="!showLateLeaveApprovalPenaltyData">
  <div class="row justify-content-center text-center pt-2">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row mt-4">
    <div class="col-md-4" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-4">
      <span class="bg-theme-title">Late Leave Approval Penalty Details</span>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToExcelLateLeaveApprovalPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToPDFLateLeaveApprovalPenalty()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-6">
      <span class="bg-theme-title"
        >Closing Date :
        {{
          lateLeaveApprovalPenaltyDetailsList.closingDate === null
            ? "Not Closed"
            : (lateLeaveApprovalPenaltyDetailsList.closingDate
              | date: "dd-MMM-yyyy")
        }}</span
      >
    </div>
  </div>
 
    <div class="row col-md-12">
      <div>
        <span style="font-size:14px;font-weight: bold;">Approver Name : </span
        >{{ lateLeaveApprovalPenaltyDetailsList.firstName }}
        {{ lateLeaveApprovalPenaltyDetailsList.lastName }}
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>Penalty Date</th>
            <th>EmployeeName</th>
            <th>leave From Date</th>
            <th>leave To Date</th>
            <th>Status</th>
            <th>leave Request Date</th>
            <th>Penalty Amount</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let penaltyDetail of lateLeaveApprovalPenaltyDetailsList.penaltyDetails;
              let penaltyDetailIndex = index;
              let penaltyCount = count
            "
          >
            <ng-container
              *ngFor="
                let detail of penaltyDetail.details;
                let detailIndex = index;
                let detailCount = count
              "
            >
              <ng-container
                *ngFor="
                  let weekDetail of detail.weekDetails;
                  let weekDetailIndex = index;
                  let weekDetailCount = count
                "
              >
                <tr *ngIf="detailIndex == 0 && weekDetailIndex == 0">
                  <td
                    [attr.rowspan]="
                      getRowSpanLateLeaveApprovalPenalty(penaltyDetail.details)
                    "
                  >
                    {{ penaltyDetail.penaltyDate | date: "dd-MMM-yyyy" }}
                  </td>
                  <td [attr.rowspan]="weekDetailCount">
                    {{ detail.approveeFName }} {{ detail.approveeLName }}
                  </td>
                  <td>{{ weekDetail.leaveFromDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.leaveToDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>
                    {{ weekDetail.leaveRequestDate | date: "dd-MMM-yyyy" }}
                  </td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr *ngIf="detailIndex != 0 && weekDetailIndex == 0">
                  <td [attr.rowspan]="weekDetailCount">
                    {{ detail.approveeFName }} {{ detail.approveeLName }}
                  </td>
                  <td>{{ weekDetail.leaveFromDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.leaveToDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>
                    {{ weekDetail.leaveRequestDate | date: "dd-MMM-yyyy" }}
                  </td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr *ngIf="weekDetailIndex != 0">
                  <td>{{ weekDetail.leaveFromDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.leaveToDate | date: "dd-MMM-yyyy" }}</td>
                  <td>{{ weekDetail.status }}</td>
                  <td>
                    {{ weekDetail.leaveRequestDate | date: "dd-MMM-yyyy" }}
                  </td>
                  <td>{{ weekDetail.penaltyAmount }}</td>
                </tr>
                <tr
                  *ngIf="
                    detailCount == detailIndex + 1 &&
                    weekDetailCount == weekDetailIndex + 1
                  "
                  style="background-color: #e1f4f7"
                >
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {{ calculateLateLeaveApprovalTotal(penaltyDetail.details) }}
                  </td>
                </tr>

                <tr
                  *ngIf="
                    penaltyCount == penaltyDetailIndex + 1 &&
                    detailCount == detailIndex + 1 &&
                    weekDetailCount == weekDetailIndex + 1
                  "
                  style="background-color: #e1f4f7"
                >
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ lateLeaveApprovalPenaltyTotal }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>